export const authenticationCodeValidation = (code: string): string | null => {
  if (!code) {
    return '認証コードが未入力です';
  } else if (!code.match(/^[0-9]{6}$/)) {
    return '6桁の半角数字で入力してください';
  }

  return null;
};
